const customForEach = (array, callback, scope) => {
  for (let i = 0; i < array.length; i += 1) {
    callback.call(scope, i, array[i]); // passes back stuff we need
  }
};

export default customForEach;
